@if (stateService.activeLocale$ | async; as activeLocale) {
  <app-top-bar [locale]="activeLocale"></app-top-bar>
}

<header *transloco="let t">
  <div class="slot-left">
    <a
      [routerLink]="'/' | addLocale"
      class="yes-header-logo desktop-only"
      title="{{ t('Home page') }}"
    >
      <svg-icon key="logo"></svg-icon>
    </a>

    <div class="header-actions header-tools-mobile">
      <a
        [routerLink]="'/cart' | translateRoute | addLocale"
        app-button="icon-button"
        class="basket"
        title="{{ t('Basket') }}"
      >
        <svg-icon key="basket"></svg-icon>
        @if (cartItemCount(); as cartItemCount) {
          <app-counter>{{ cartItemCount }} </app-counter>
        }
      </a>

      @if (isLoggedIn) {
        <a
          [routerLink]="'/panel/wishlist' | addLocale"
          app-button="icon-button"
          class="wishlist"
          title="{{ t('Wishlist') }}"
        >
          <svg-icon key="wishlist"></svg-icon>
          @if (wishlistCount()) {
            <app-counter>{{ wishlistCount() }}</app-counter>
          }
        </a>
      }
    </div>
  </div>

  <app-megamenu (isOpened)="onMenuOpenChange($event)" />
  <div class="slot-center mobile-only">
    <a
      [routerLink]="'/' | addLocale"
      class="yes-header-logo mobile-only"
      title="{{ t('Home page') }}"
    >
      <svg-icon key="logo"></svg-icon>
    </a>
  </div>

  <div class="slot-right">
    <div class="header-actions">
      <form class="header-search" (ngSubmit)="onSearch()">
        <input
          class="input input-search lbx-searchbox"
          [attr.aria-label]="t('Search')"
          [class.filled]="!!searchInputValue"
          [placeholder]="t('Search')"
          [(ngModel)]="searchInputValue"
          (click)="onSearchInputClick($event)"
          type="search"
          name="search"
        />
        <svg-icon key="search"></svg-icon>
        <button type="submit" class="visually-hidden">{{ t('Submit') }}</button>
      </form>

      @if (isLoggedIn) {
        <a
          [routerLink]="'/panel' | addLocale"
          app-button="icon-button"
          class="account desktop-only"
          title="{{ t('Account') }}"
        >
          <svg-icon key="account"></svg-icon>
        </a>
      } @else {
        <a
          [routerLink]="'/login' | translateRoute | addLocale"
          app-button="icon-button"
          class="account"
          title="{{ t('Account') }}"
        >
          <svg-icon key="account"></svg-icon>
        </a>
      }

      @if (isLoggedIn) {
        <a
          [routerLink]="'/panel/wishlist' | addLocale"
          app-button="icon-button"
          class="wishlist desktop-only"
          title="{{ t('Wishlist') }}"
        >
          <svg-icon key="wishlist"></svg-icon>
          @if (wishlistCount()) {
            <app-counter>{{ wishlistCount() }}</app-counter>
          }
        </a>
      }

      <a
        [routerLink]="'/cart' | translateRoute | addLocale"
        app-button="icon-button"
        class="basket desktop-only"
        title="{{ t('Basket') }}"
      >
        <svg-icon key="basket"></svg-icon>
        @if (cartItemCount(); as cartItemCount) {
          <app-counter>{{ cartItemCount }} </app-counter>
        }
      </a>
    </div>

    <div class="header-tools-mobile">
      <button
        app-button="icon-button"
        [title]="t('Search')"
        (click)="onMobileSearchToggle()"
      >
        <svg-icon key="search"></svg-icon>
      </button>
      <button
        app-button="icon-button"
        class="hamburger"
        (click)="onHamburger()"
        title="{{ t('Menu') }}"
      >
        <svg-icon key="hamburger"></svg-icon>
      </button>
    </div>

    <div
      class="header-search header-search-mobile"
      [style.display]="isMobileSearchOpen ? 'flex' : 'none'"
    >
      <button
        app-button="icon-button"
        [title]="t('Close search bar')"
        (click)="onMobileSearchToggle()"
      >
        <svg-icon key="close"></svg-icon>
      </button>
      <form (ngSubmit)="onSearch()">
        <input
          #mobileSearchInput
          [attr.aria-label]="t('Search')"
          class="input input-search lbx-searchbox"
          [class.filled]="!!searchInputValue"
          [placeholder]="t('Search')"
          [(ngModel)]="searchInputValue"
          type="search"
          name="search"
        />
        <button type="submit" class="visually-hidden">{{ t('Submit') }}</button>
      </form>
    </div>
  </div>

  <div class="ng-content-wrapper" [style.z-index]="ngContentZIndex()">
    <ng-content />
  </div>
</header>
